import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import * as Scrivito from "scrivito";
import { Button, Icon } from "components";
import { projectTranslations } from "config/locals/projectTranslations";

import { useTranslate } from "hooks";
import s from "./ProjectListTableRow.module.scss";

export const FilterBtn = Scrivito.connect(
  ({ name, count, color, icon, iconPrefix, isActive, onClick }) => {
    const translate = useTranslate();
    const handleClick = useCallback(() => {
      onClick(name);
    }, [name, onClick]);

    const translateProp = useMemo(
      () => (name ? `PROJECT_STATUS_${name}` : ""),
      [name],
    );

    return (
      <Button
        data-testid={translateProp}
        color="filter"
        active={isActive}
        onClick={handleClick}
        className={cx(s.filterBtn, { [s.checked]: isActive }, "text-nowrap")}
        square={true}
      >
        {color && (
          <div
            className={cx("mr-2 rounded-circle icon-12")}
            style={{ background: color }}
          />
        )}
        {icon && <Icon iconName={icon} prefix={iconPrefix} />}
        {projectTranslations[translateProp.toUpperCase()]
          ? translate(translateProp)
          : name}
        {(!!count || +count === 0) && ` (${count})`}
      </Button>
    );
  },
);
